import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useBlueprintSelectStyles } from './BlueprintStoreyLevelSelect';
import type { PdfImportBuildingOption } from './pdf-blueprint-underlay-dialog.types';

type PdfImportBuildingSelectProps = {
  value: string | undefined;
  buildings: readonly PdfImportBuildingOption[];
  disabled?: boolean;
  onChange: (buildingId: string) => void;
};

/**
 * Building dropdown in PDF import step 2. The placed pages show only while
 * that building is selected.
 */
export const PdfImportBuildingSelect: React.FC<
  PdfImportBuildingSelectProps
> = ({ value, buildings, disabled, onChange }) => {
  const { classes } = useBlueprintSelectStyles({ fullWidth: false });

  return (
    <FormControl size="small" disabled={disabled} className={classes.control}>
      <Select
        value={value ?? ''}
        className={classes.select}
        inputProps={{ 'aria-label': 'Building' }}
        onChange={(event) => onChange(event.target.value)}
      >
        {buildings.map((building) => (
          <MenuItem
            key={building.id}
            value={building.id}
            sx={{
              fontSize: (theme) => theme.typography.body2.fontSize,
              fontWeight: (theme) => theme.typography.body2.fontWeight,
              lineHeight: (theme) => theme.typography.body2.lineHeight,
            }}
          >
            {building.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
